import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-application-usage', {
        url: '/reports/appusage',
        component: 'companyApplicationUsageReport',
        resolve: {
            companyApplications,
            computersProtectionApplications,
            computersCustomApplications,
        }
    });
}

/** @ngInject */
function companyApplications(ApplicationUsageReportService, companyId) {
    return ApplicationUsageReportService.usageReport.getCompanyApplications({companyId}).$promise;
}
/** @ngInject */
function computersProtectionApplications(ApplicationUsageReportService, companyId) {
    const appTypeId = 9;
    return ApplicationUsageReportService.usageReport.getFilterByTypeIdApplications({companyId, appTypeId}).$promise;
}
/** @ngInject */
function computersCustomApplications(ApplicationUsageReportService, companyId) {
    const appTypeId = 2;
    return ApplicationUsageReportService.usageReport.getFilterByTypeIdApplications({companyId, appTypeId}).$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/application-usage-report/application-usage-report.state.js